export const footerLinks = {
    'qa-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.qa/flights/to-riyadh/',
                    title: 'رياض',
                },
                {
                    href: 'https://www.wingie.qa/flights/to-jeddah/',
                    title: 'جدة',
                },
                {
                    href: 'https://www.wingie.qa/flights/to-dammam/',
                    title: 'الدمام',
                },
                {
                    href: 'https://www.wingie.qa/flights/to-manila/',
                    title: 'مانيلا',
                },
                {
                    href: 'https://www.wingie.qa/flights/to-chennai/',
                    title: 'تشيناي',
                },
                {
                    href: 'https://www.wingie.qa/flights/to-delhi/',
                    title: 'دلهي',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.qa/flights/az-azerbaijan/',
                    title: 'أذربيجان',
                },
                {
                    href: 'https://www.wingie.qa/flights/bh-bahrain/',
                    title: 'البحرين',
                },
                {
                    href: 'https://www.wingie.qa/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://www.wingie.qa/flights/in-india/',
                    title: 'الهند',
                },
                {
                    href: 'https://www.wingie.qa/flights/jo-jordan/',
                    title: 'الأردن',
                },
                {
                    href: 'https://www.wingie.qa/flights/ke-kenya/',
                    title: 'كينيا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.qa/flights/airlines/saudi-arabian-airlines/',
                    title: 'السعودية',
                },
                {
                    href: 'https://www.wingie.qa/flights/airlines/flynas/',
                    title: 'طيران ناس',
                },
                {
                    href: 'https://www.wingie.qa/flights/airlines/qatar-airways/',
                    title: 'الخطوط الجوية القطرية\n',
                },
                {
                    href: 'https://www.wingie.qa/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
                {
                    href: 'https://www.wingie.qa/flights/airlines/etihad-airways/',
                    title: 'شَرِكَة ٱلْاِتِّحَاد لِلطَّيْرَان',
                },
                {
                    href: 'https://www.wingie.qa/flights/airlines/royal-jordanian/',
                    title: 'الملكيَّة الأردنيَّة',
                },
            ],
        },
    ],
    'qa-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://www.wingie.qa/en/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://www.wingie.qa/en/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/bd-bangladesh/',
                    title: 'Bangladesh',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/eg-egypt/',
                    title: 'Egypt',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/jo-jordan/',
                    title: 'Jordan',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://www.wingie.qa/en/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/airlines/flyadeal/',
                    title: 'flyadeal',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/airlines/nile-air/',
                    title: 'Nile Air',
                },
                {
                    href: 'https://www.wingie.qa/en/flights/airlines/emirates/',
                    title: 'Emirates',
                },
            ],
        },
    ],
    'qa-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://www.wingie.qa/es/vuelos/a-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/a-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/a-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/a-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/a-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/a-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.qa/es/vuelos/az-azerbaijan/',
                    title: 'Azerbaiyán',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/bh-bahrain/',
                    title: 'Bahréin',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/eg-egypt/',
                    title: 'Egipto',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://www.wingie.qa/es/vuelos/companias-aereas/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/companias-aereas/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/companias-aereas/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/companias-aereas/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.qa/es/vuelos/companias-aereas/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'qa-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.qa/de/flug/nach-riad/',
                    title: 'Riad',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/nach-dschidda/',
                    title: 'Dschidda',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/nach-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/nach-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/nach-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/nach-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.qa/de/flug/az-aserbaidschan/',
                    title: 'Aserbaidschan',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/eg-aegypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/in-indien/',
                    title: 'Indien',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/jo-jordanien/',
                    title: 'Jordanien',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/ke-kenia/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.qa/de/flug/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.qa/de/flug/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'qa-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.qa/ru/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/to-jeddah/',
                    title: 'Джедда',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.qa/ru/flights/az-azerbaijan/',
                    title: 'Азербайджан',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.qa/ru/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.qa/ru/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'qa-it': [
        {
            title: 'Principali destinazioni',
            items: [
                { href: 'https://www.wingie.qa/it/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://www.wingie.qa/it/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://www.wingie.qa/it/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/it/flights/to-manila/', title: 'Manila' },
                { href: 'https://www.wingie.qa/it/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/it/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                { href: 'https://www.wingie.qa/it/flights/az-azerbaijan/', title: 'Azerbaigian' },
                { href: 'https://www.wingie.qa/it/flights/bh-bahrain/', title: 'Bahrein' },
                { href: 'https://www.wingie.qa/it/flights/eg-egypt/', title: 'Egitto' },
                { href: 'https://www.wingie.qa/it/flights/in-india/', title: 'India' },
                { href: 'https://www.wingie.qa/it/flights/jo-jordan/', title: 'Giordania' },
                { href: 'https://www.wingie.qa/it/flights/ke-kenya/', title: 'Kenya' },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                { href: 'https://www.wingie.qa/it/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/it/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/it/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/it/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/it/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/it/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-fr': [
        {
            title: 'Principales destinations',
            items: [
                { href: 'https://www.wingie.qa/fr/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://www.wingie.qa/fr/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://www.wingie.qa/fr/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/fr/flights/to-manila/', title: 'Manille' },
                { href: 'https://www.wingie.qa/fr/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/fr/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                { href: 'https://www.wingie.qa/fr/flights/az-azerbaijan/', title: 'Azerbaïdjan' },
                { href: 'https://www.wingie.qa/fr/flights/bh-bahrain/', title: 'Bahreïn' },
                { href: 'https://www.wingie.qa/fr/flights/eg-egypt/', title: 'Égypte' },
                { href: 'https://www.wingie.qa/fr/flights/in-india/', title: 'Inde' },
                { href: 'https://www.wingie.qa/fr/flights/jo-jordan/', title: 'Jordanie' },
                { href: 'https://www.wingie.qa/fr/flights/ke-kenya/', title: 'Kenya' },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                { href: 'https://www.wingie.qa/fr/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/fr/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/fr/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/fr/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/fr/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/fr/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-pt': [
        {
            title: 'Principais destinos',
            items: [
                { href: 'https://www.wingie.qa/pt/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://www.wingie.qa/pt/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://www.wingie.qa/pt/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/pt/flights/to-manila/', title: 'Manila' },
                { href: 'https://www.wingie.qa/pt/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/pt/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { href: 'https://www.wingie.qa/pt/flights/az-azerbaijan/', title: 'Azerbaijão' },
                { href: 'https://www.wingie.qa/pt/flights/bh-bahrain/', title: 'Bahrein' },
                { href: 'https://www.wingie.qa/pt/flights/eg-egypt/', title: 'Egito' },
                { href: 'https://www.wingie.qa/pt/flights/in-india/', title: 'Índia' },
                { href: 'https://www.wingie.qa/pt/flights/jo-jordan/', title: 'Jordânia' },
                { href: 'https://www.wingie.qa/pt/flights/ke-kenya/', title: 'Quênia' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { href: 'https://www.wingie.qa/pt/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/pt/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/pt/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/pt/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/pt/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/pt/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-ro': [
        {
            title: 'Top destinații',
            items: [
                { href: 'https://www.wingie.qa/ro/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://www.wingie.qa/ro/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://www.wingie.qa/ro/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/ro/flights/to-manila/', title: 'Manila' },
                { href: 'https://www.wingie.qa/ro/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/ro/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { href: 'https://www.wingie.qa/ro/flights/az-azerbaijan/', title: 'Azerbaidjan' },
                { href: 'https://www.wingie.qa/ro/flights/bh-bahrain/', title: 'Bahrain' },
                { href: 'https://www.wingie.qa/ro/flights/eg-egypt/', title: 'Egipt' },
                { href: 'https://www.wingie.qa/ro/flights/in-india/', title: 'India' },
                { href: 'https://www.wingie.qa/ro/flights/jo-jordan/', title: 'Iordania' },
                { href: 'https://www.wingie.qa/ro/flights/ke-kenya/', title: 'Kenya' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { href: 'https://www.wingie.qa/ro/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/ro/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/ro/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/ro/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/ro/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/ro/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-pl': [
        {
            title: 'Najpopularniejsze kierunki',
            items: [
                { href: 'https://www.wingie.qa/pl/flights/to-riyadh/', title: 'Rijad' },
                { href: 'https://www.wingie.qa/pl/flights/to-jeddah/', title: 'Dżudda' },
                { href: 'https://www.wingie.qa/pl/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/pl/flights/to-manila/', title: 'Manila' },
                { href: 'https://www.wingie.qa/pl/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/pl/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { href: 'https://www.wingie.qa/pl/flights/az-azerbaijan/', title: 'Azerbejdżan' },
                { href: 'https://www.wingie.qa/pl/flights/bh-bahrain/', title: 'Bahrajn' },
                { href: 'https://www.wingie.qa/pl/flights/eg-egypt/', title: 'Egipt' },
                { href: 'https://www.wingie.qa/pl/flights/in-india/', title: 'Indie' },
                { href: 'https://www.wingie.qa/pl/flights/jo-jordan/', title: 'Jordania' },
                { href: 'https://www.wingie.qa/pl/flights/ke-kenya/', title: 'Kenia' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { href: 'https://www.wingie.qa/pl/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/pl/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/pl/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/pl/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/pl/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/pl/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-lt': [
        {
            title: 'Populiariausi maršrutai',
            items: [
                { href: 'https://www.wingie.qa/lt/flights/to-riyadh/', title: 'Rijadas' },
                { href: 'https://www.wingie.qa/lt/flights/to-jeddah/', title: 'Džida' },
                { href: 'https://www.wingie.qa/lt/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/lt/flights/to-manila/', title: 'Manila' },
                { href: 'https://www.wingie.qa/lt/flights/to-chennai/', title: 'Čenajus' },
                { href: 'https://www.wingie.qa/lt/flights/to-delhi/', title: 'Delis' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { href: 'https://www.wingie.qa/lt/flights/az-azerbaijan/', title: 'Azerbaidžanas' },
                { href: 'https://www.wingie.qa/lt/flights/bh-bahrain/', title: 'Bahreinas' },
                { href: 'https://www.wingie.qa/lt/flights/eg-egypt/', title: 'Egiptas' },
                { href: 'https://www.wingie.qa/lt/flights/in-india/', title: 'Indija' },
                { href: 'https://www.wingie.qa/lt/flights/jo-jordan/', title: 'Jordanija' },
                { href: 'https://www.wingie.qa/lt/flights/ke-kenya/', title: 'Kenija' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { href: 'https://www.wingie.qa/lt/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/lt/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/lt/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/lt/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/lt/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/lt/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-uz': [
        {
            title: "Mashhur yo'nalishlar",
            items: [
                { href: 'https://www.wingie.qa/uz/flights/to-riyadh/', title: 'Riyod' },
                { href: 'https://www.wingie.qa/uz/flights/to-jeddah/', title: 'Jidda' },
                { href: 'https://www.wingie.qa/uz/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/uz/flights/to-manila/', title: 'Manila' },
                { href: 'https://www.wingie.qa/uz/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/uz/flights/to-delhi/', title: 'Dehli' },
            ],
        },
        {
            title: 'Mashhur davlatlar',
            items: [
                { href: 'https://www.wingie.qa/uz/flights/az-ozarbayjon/', title: 'Ozarbayjon' },
                { href: 'https://www.wingie.qa/uz/flights/bh-bahrayn/', title: 'Bahrayn' },
                { href: 'https://www.wingie.qa/uz/flights/eg-misr/', title: 'Misr' },
                { href: 'https://www.wingie.qa/uz/flights/in-hindiston/', title: 'Hindiston' },
                { href: 'https://www.wingie.qa/uz/flights/jo-iordaniya/', title: 'Iordaniya' },
                { href: 'https://www.wingie.qa/uz/flights/ke-keniya/', title: 'Keniya' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { href: 'https://www.wingie.qa/uz/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/uz/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/uz/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/uz/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/uz/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/uz/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-sr': [
        {
            title: 'Популарне дестинације',
            items: [
                { href: 'https://www.wingie.qa/sr/flights/to-riyadh/', title: 'Ријад' },
                { href: 'https://www.wingie.qa/sr/flights/to-jeddah/', title: 'Џеда' },
                { href: 'https://www.wingie.qa/sr/flights/to-dammam/', title: 'Дамам' },
                { href: 'https://www.wingie.qa/sr/flights/to-manila/', title: 'Манила' },
                { href: 'https://www.wingie.qa/sr/flights/to-chennai/', title: 'Ченај' },
                { href: 'https://www.wingie.qa/sr/flights/to-delhi/', title: 'Делхи' },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                { href: 'https://www.wingie.qa/sr/flights/az-azerbejdzan/', title: 'Азербејџан' },
                { href: 'https://www.wingie.qa/sr/flights/bh-bahrein/', title: 'Бахреин' },
                { href: 'https://www.wingie.qa/sr/flights/eg-egipat/', title: 'Египат' },
                { href: 'https://www.wingie.qa/sr/flights/in-indija/', title: 'Индија' },
                { href: 'https://www.wingie.qa/sr/flights/jo-jordan/', title: 'Јордан' },
                { href: 'https://www.wingie.qa/sr/flights/ke-kenija/', title: 'Кенија' },
            ],
        },
        {
            title: 'Популарне авио-компаније',
            items: [
                { href: 'https://www.wingie.qa/sr/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/sr/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/sr/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/sr/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/sr/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/sr/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-ky': [
        {
            title: 'Популярдуу багыттар',
            items: [
                { href: 'https://www.wingie.qa/ky/flights/to-riyadh/', title: 'Эр-Рияд' },
                { href: 'https://www.wingie.qa/ky/flights/to-jeddah/', title: 'Жидда' },
                { href: 'https://www.wingie.qa/ky/flights/to-dammam/', title: 'Даммам' },
                { href: 'https://www.wingie.qa/ky/flights/to-manila/', title: 'Манила' },
                { href: 'https://www.wingie.qa/ky/flights/to-chennai/', title: 'Ченнай' },
                { href: 'https://www.wingie.qa/ky/flights/to-delhi/', title: 'Дели' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { href: 'https://www.wingie.qa/ky/flights/az-azerbyzhan/', title: 'Азербайжан' },
                { href: 'https://www.wingie.qa/ky/flights/bh-bahreyn/', title: 'Бахрейн' },
                { href: 'https://www.wingie.qa/ky/flights/eg-mesir/', title: 'Мысыр' },
                { href: 'https://www.wingie.qa/ky/flights/in-indya/', title: 'Индия' },
                { href: 'https://www.wingie.qa/ky/flights/jo-iordanya/', title: 'Иордания' },
                { href: 'https://www.wingie.qa/ky/flights/ke-keniya/', title: 'Кения' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { href: 'https://www.wingie.qa/ky/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/ky/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/ky/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/ky/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/ky/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/ky/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-tg': [
        {
            title: 'Самаратарин ҷоҳои сафар',
            items: [
                { href: 'https://www.wingie.qa/tg/flights/to-riyadh/', title: 'Рияд' },
                { href: 'https://www.wingie.qa/tg/flights/to-jeddah/', title: 'Ҷидда' },
                { href: 'https://www.wingie.qa/tg/flights/to-dammam/', title: 'Даммам' },
                { href: 'https://www.wingie.qa/tg/flights/to-manila/', title: 'Манила' },
                { href: 'https://www.wingie.qa/tg/flights/to-chennai/', title: 'Ченнай' },
                { href: 'https://www.wingie.qa/tg/flights/to-delhi/', title: 'Дели' },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                { href: 'https://www.wingie.qa/tg/flights/az-ozarboyzhon/', title: 'Озарбойҷон' },
                { href: 'https://www.wingie.qa/tg/flights/bh-bahrayn/', title: 'Баҳрайн' },
                { href: 'https://www.wingie.qa/tg/flights/eg-misr/', title: 'Миср' },
                { href: 'https://www.wingie.qa/tg/flights/in-hinduston/', title: 'Ҳиндустон' },
                { href: 'https://www.wingie.qa/tg/flights/jo-urdun/', title: 'Урдун' },
                { href: 'https://www.wingie.qa/tg/flights/ke-keniya/', title: 'Кения' },
            ],
        },
        {
            title: 'Компанияҳои машҳури парвозӣ',
            items: [
                { href: 'https://www.wingie.qa/tg/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/tg/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/tg/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/tg/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/tg/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/tg/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-kk': [
        {
            title: 'Танымал бағыттар',
            items: [
                { href: 'https://www.wingie.qa/kk/flights/to-riyadh/', title: 'Эр-Рияд' },
                { href: 'https://www.wingie.qa/kk/flights/to-jeddah/', title: 'Жидда' },
                { href: 'https://www.wingie.qa/kk/flights/to-dammam/', title: 'Даммам' },
                { href: 'https://www.wingie.qa/kk/flights/to-manila/', title: 'Манила' },
                { href: 'https://www.wingie.qa/kk/flights/to-chennai/', title: 'Ченнай' },
                { href: 'https://www.wingie.qa/kk/flights/to-delhi/', title: 'Дели' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { href: 'https://www.wingie.qa/kk/flights/az-azerbyzhan/', title: 'Әзербайжан' },
                { href: 'https://www.wingie.qa/kk/flights/bh-bahreyn/', title: 'Бахрейн' },
                { href: 'https://www.wingie.qa/kk/flights/eg-mesir/', title: 'Мысыр' },
                { href: 'https://www.wingie.qa/kk/flights/in-hindystan/', title: 'Үндістан' },
                { href: 'https://www.wingie.qa/kk/flights/jo-iordaniya/', title: 'Иордания' },
                { href: 'https://www.wingie.qa/kk/flights/ke-keniya/', title: 'Кения' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { href: 'https://www.wingie.qa/kk/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/kk/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/kk/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/kk/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/kk/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/kk/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-nl': [
        {
            title: 'Populaire bestemmingen',
            items: [
                { href: 'https://www.wingie.qa/nl/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://www.wingie.qa/nl/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://www.wingie.qa/nl/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://www.wingie.qa/nl/flights/to-manila/', title: 'Manilla' },
                { href: 'https://www.wingie.qa/nl/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://www.wingie.qa/nl/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { href: 'https://www.wingie.qa/nl/flights/az-azerbaidjan/', title: 'Azerbeidzjan' },
                { href: 'https://www.wingie.qa/nl/flights/bh-bahrein/', title: 'Bahrein' },
                { href: 'https://www.wingie.qa/nl/flights/eg-egypte/', title: 'Egypte' },
                { href: 'https://www.wingie.qa/nl/flights/in-india/', title: 'India' },
                { href: 'https://www.wingie.qa/nl/flights/jo-jordanie/', title: 'Jordanië' },
                { href: 'https://www.wingie.qa/nl/flights/ke-kenia/', title: 'Kenia' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { href: 'https://www.wingie.qa/nl/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://www.wingie.qa/nl/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://www.wingie.qa/nl/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://www.wingie.qa/nl/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://www.wingie.qa/nl/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://www.wingie.qa/nl/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'qa-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.qa/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.qa/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.qa/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.qa/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.qa/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.qa/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.qa/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.qa/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.qa/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.qa/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.qa/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.qa/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.qa/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.qa/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.qa/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.qa/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.qa/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.qa/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.qa/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.qa/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.qa/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.qa/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.qa/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.qa/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.qa/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.qa/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.qa/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.qa/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.qa/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.qa/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.qa/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.qa/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.qa/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.qa/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.qa/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.qa/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.qa/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.qa/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.qa/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.qa/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.qa/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.qa/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.qa/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.qa/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.qa/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.qa/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.qa/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.qa/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.qa/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.qa/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.qa/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.qa/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.qa/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.qa/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.qa/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.qa/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.qa/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.qa/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.qa/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.qa/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.qa/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.qa/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.qa/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.qa/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.qa/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.qa/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.qa/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.qa/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.qa/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.qa/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.qa/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.qa/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.qa/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.qa/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.qa/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.qa/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.qa/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.qa/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.qa/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.qa/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.qa/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.qa/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.qa/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.qa/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.qa/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.qa/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.qa/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.qa/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.qa/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.qa/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.qa/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.qa/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.qa/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.qa/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.qa/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.qa/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.qa/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.qa/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.qa/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.qa/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.qa/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.qa/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.qa/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.qa/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.qa/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.qa/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.qa/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.qa/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.qa/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.qa/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.qa/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.qa/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.qa/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.qa/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.qa/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.qa/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.qa/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.qa/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.qa/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'qa-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.qa/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.qa/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.qa/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.qa/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.qa/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.qa/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.qa/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.qa/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.qa/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.qa/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.qa/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.qa/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.qa/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.qa/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.qa/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.qa/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.qa/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.qa/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}